import { render, staticRenderFns } from "./DirectorShiftsQuota.vue?vue&type=template&id=068a951c&lang=pug&"
import script from "./DirectorShiftsQuota.vue?vue&type=script&lang=js&"
export * from "./DirectorShiftsQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports